<template>
  <div style="background-color: #fafafa;padding: 20px">

    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/package' }">提成规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="font-size: 25px;margin-top: 15px;width: 100%">
      <div><p>提成规则管理</p></div>
    </div>

    <div class="app-container">
      <div style="display: flex;justify-content: space-between;margin-bottom: 8px">
        <div>
          <el-button icon="el-icon-plus" @click="toSavepackage" size="mini"
                     style="background: #ff6633; color: white;border-radius:  4px 0 0 4px; border-right: none;">新增提成规则
          </el-button>
          <el-button @click="openUploadPackage"
                     style="margin-left: 0;margin-right: 10px;border-radius:  0 4px 4px 0;border-left: none" size="mini">批量上传
          </el-button>
          <el-select class="selectBorderRadius" v-model="includeSale" placeholder="请先选择下方供应商" size="mini"
                     :disabled="!queryParams.supplierName" style="width: 200px">
            <el-option
              label="含导购员名单"
              :value="true">
            </el-option>

            <el-option
              label="不含导购员名单"
              :value="false">
            </el-option>
          </el-select>

          <el-button :loading="downloadLoading" @click="downloadRuleTemplate" style="border-radius: 0 5px 5px 0"
                     size="mini">
            下载分配表
          </el-button>

          <el-button :loading="uploadLoading" @click="uploadRuleOpen" size="mini">上传应用分配表
          </el-button>
          <input type="file" ref="uploadRuleTemplate" v-show="false" accept=".xls,.xlsx" @change="uploadRule"/>
        </div>

        <div>
          <el-button :disabled="true" size="mini" style="background: #F5F7FA;border-radius: 4px 0 0 4px;">
            未分配规则导购
          </el-button>
          <el-button :loading="savepackageLoading" size="mini" @click="queryUnassignedSaleCount"
                     style="margin-left: 0px;border-radius: 0;">
            {{ unassignedSaleCount != undefined ? unassignedSaleCount + '人' : '查询人数' }}
          </el-button>
          <el-button @click="centerDialogVisible = true" size="mini"
                     style="margin-right: 10px; margin-left: 0;border-radius:  0 4px 4px 0 ;">
            下载名单
          </el-button>
        </div>
      </div>

      <div style="background-color: #EDEDED;padding: 10px">
        <el-form :model="queryParams" ref="packageQuery"
                 style="display: flex;width: 100%;" class="activityForm">
          <el-form-item prop="supplierName" style="width: 35%">
            <el-autocomplete
              style="width: 100%"
              clearable
              ref="el_auto"
              class="inline-input"
              value-key="name"
              v-model="queryParams.supplierName"
              :fetch-suggestions="querySupplier"
              placeholder="供应商"
              @select="supplierChange"
            >
              <i
                class="el-icon-arrow-down"
                slot="suffix">
              </i>
              <template slot-scope="{ item }">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.name"
                  placement="right-end"
                >
                  <div class="query-item-text" style="overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap">
                    {{ item.name }}
                  </div>
                </el-tooltip>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item prop="parentBrand" style="margin-left: 10px;width: 15%">
            <el-autocomplete
              style="width: 100%"
              :disabled="!queryParams.supplierName"
              clearable @clear="() => queryParams.parentBrand = null"
              class="inline-input"
              value-key="name"
              v-model="queryParams.parentBrandName"
              :fetch-suggestions="queryParentBrand"
              placeholder="品牌"
              @select="parentBrandChange"
            >
              <i
                class="el-icon-arrow-down"
                slot="suffix">
              </i>
            </el-autocomplete>
          </el-form-item>

          <el-form-item prop="search.value" style="margin-left: 10px;width: 25%">
            <el-input
              placeholder="请输入内容"
              clearable
              maxlength="100"
              v-model="queryParams.search.value"
            >
              <el-select slot="prepend" style="width: 120px" v-model="queryParams.search.name" placeholder="请选择">
                <el-option label="规则名" value="packageName"></el-option>
                <el-option label="规则id" value="packageId"></el-option>
                <el-option label="barcode" value="barcode"></el-option>
                <el-option label="商品名" value="productName"></el-option>
                <el-option label="导购id" value="saleId"></el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item prop="range" style="margin-left: 10px;width: 25%;">
            <el-date-picker
              style="width:100%"
              type="daterange"
              v-model="queryParams.range"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="-"
              unlink-panels
              :editable="false"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>


          <el-form-item style="margin: 0 10px;">
            <el-button type="cyan" icon="el-icon-search" @click="handleQuery" style="background: #ff6633;color: white">
              搜索
            </el-button>
            <!--          <el-button icon="el-icon-refresh" @click="resetQuery('packageQuery')">重置</el-button>-->
          </el-form-item>
        </el-form>
      </div>

      <el-button size="mini" style="margin: 10px 0" :class="packageIds.length === 0 ? 'is-disabled' : ''" :disabled="packageIds.length === 0" v-if="packages && packages.length > 0" @click="timeRangOpened()">批量更改有效期</el-button>
      <el-table v-loading="loading"
                id="partnerPriceTable"
                border
                :row-class-name="tableRowClassName"
                :data="packages">
        <el-table-column width="80" align="center">
          <template slot="header" slot-scope="scope">
            <div style="display: flex;justify-content: center; align-items: center;height: 30px;line-height: 30px">
              <el-checkbox-group v-model="checkAll" @change="(val) => checkedClickAll(val)" style="margin-right: 10px;margin-top: 5px">
                <el-checkbox label="0"/>
              </el-checkbox-group>
              <div>序号</div>
            </div>
          </template>
          <template slot-scope="scope">
            <div style="display: flex;justify-content: center; align-items: center;height: 30px;line-height: 30px">
              <el-checkbox-group v-model="scope.row.checked" @change="(val) => checkedClick(val,scope.row.packageId,scope.$index)" style="margin-right: 10px;margin-top: 5px">
                <el-checkbox label="0"/>
              </el-checkbox-group>
              <div>{{scope.$index + 1}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="规则id" width="100" align="center" prop="packageId"/>
        <el-table-column label="规则名称" align="center" prop="packageName"/>
        <el-table-column label="有效期" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime }} -- {{ scope.row.endTime }}<br/>
            <span v-if="scope.row.monthRange" :style="{color:'white',backgroundColor: scope.row.monthRangeColor,fontSize: '10px',padding: '4px',borderRadius: '4px'}">{{scope.row.monthRange}}</span>
          </template>
        </el-table-column>
        <el-table-column label="供应商" show-overflow-tooltip align="center" prop="supplierName"/>
        <el-table-column label="品牌" show-overflow-tooltip align="center" prop="parentBrand">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.parentBrand && scope.row.parentBrand.length > 3"
              placement="top"
              effect="dark">
              <div slot="content" style="max-width: 800px; line-height: 1.4;">
                {{scope.row.parentBrand.join(', ')}}
              </div>
              <div>
                <div v-for="(item, index) in scope.row.parentBrand.slice(0, 3)" :key="index">{{item}}</div>
                <div>.&nbsp;&nbsp;.&nbsp;&nbsp;.&nbsp;&nbsp;</div>
              </div>
            </el-tooltip>
            <div v-else>
              <div v-for="(item, index) in scope.row.parentBrand" :key="index">{{item}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="详情" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="dialogOpened(scope.row)">点击查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
              <div><el-button type="text" style="padding: 7px 20px" @click="copyPackage(scope.row)">复制为新规则</el-button></div>
              <div><el-button type="text" style="padding: 7px 20px" @click="toEditPackage(scope.row)">修改产品及时间</el-button></div>
              <div><el-button type="text" style="padding: 7px 20px" @click="timeRangOpened(scope.row)">更改有效期</el-button></div>
          </template>
        </el-table-column>

        <el-table-column label="应用范围" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="applyDialogOpened(scope.$index)">设置并发布</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--      <pagination-->
      <!--        v-if="pageInfo.total>0"-->
      <!--        :total="pageInfo.total"-->
      <!--        :page.sync="queryParams.pageNum"-->
      <!--        :limit.sync="queryParams.pageSize"-->
      <!--        @pagination="handleQuery"-->
      <!--      />-->
    </div>

    <el-dialog
      class="downLoadManager"
      :visible.sync="centerDialogVisible"
      width="30%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      center>

      <el-form label-position="top" label-width="80px" :rules="rules" ref="form" :model="form"
               style="padding: 0px 30px">
        <el-form-item label="请选择要下载的未分配规则的导购范围" prop="saleArea">
          <el-radio-group v-model="form.saleArea">
            <el-radio style="display: block; margin-bottom: 10px" :label="1">所有未分配规则签约导购</el-radio>
            <el-radio style="display: block; margin-bottom: 10px" :label="2">
              忽略近
              <el-input-number size="mini" :disabled="form.saleArea == 1" v-model="form.day" :min="1" :controls="false"
                               style="width: 50px"/>
              天新签约导购
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请选择供应商（可多选）">
          <el-select popper-class="el-select" v-model="form.supplierId" multiple value-key="id" placeholder="所有供应商"
                     :filter-method="supplierFilter" filterable @visible-change="cleanAllCheckOptions"
                     clearable collapse-tags>
            <select-all-option v-model="form.supplierId" :auto-select="true" data-value="id"
                               :data="(showAllCheckOptions ? allCheckOptions : suppliers)"/>
            <el-option
              v-for="item in (showAllCheckOptions ? allCheckOptions : suppliers)"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDownloadUnassignedSale">取消下载</el-button>
        <el-button type="primary" :disabled="!form.supplierId.length" @click="downloadUnassignedSale"
                   :loading="downloadLoading">确定下载
        </el-button>
      </div>
    </el-dialog>


    <el-dialog title="规则详情" :visible.sync="dialogOpen" width="960px" append-to-body @close="dialogClose">
      <el-form v-if="packageVo" :model="packageVo" label-width="100px" class="activityForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="规则名称">
              {{ packageVo.packageName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效时间">
              {{ packageVo.startTime }} -- {{ packageVo.endTime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附加文案">
              {{ packageVo.packageDescription }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="方案叠加设定">
              <el-checkbox disabled :checked="packageVo.overlayInPackage == 1">规则内可互相叠加</el-checkbox>
              <el-checkbox disabled :checked="packageVo.overlayBetweenPackages == 1">规则间可互相叠加</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="margin-left: 50px" v-if="packageVo">
        <div v-if="packageVo.activitys.length === 1 && packageVo.activitys[0].activityType === 1">
          <el-button type="primary" size="mini"
                     style="position: absolute; top: 90px; right: 30px;" :loading="downLoadPackageDetailLoading"
                     @click="downLoadPackageDetail">
            下载规则详情表格
          </el-button>
        </div>

        <el-form :model="packageVo.activitys" label-width="70px" class="activityForm">
          <el-row v-for="(activity,index) in packageVo.activitys" :key="index"
                  :style="{marginTop: index > 0?'50px':''}">
            <el-col :span="24">
              <h2>提成方案{{ index + 1 }}</h2>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案名称">
                {{ activity.activityName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="简单方案">
                {{ activity.activityType == 1 ? '是' : '否' }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附加文案">
                {{ activity.activityDescription }}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="结算周期">
                {{ activity.cycleDay | cycleDayFilter }}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="奖励基准">
                {{ activity.rewardAlgorithm.rewardBenchmark | rewardBenchmarkFilter }}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="组合方式">
                {{ activity.rewardAlgorithm.combinationMode | combinationModeFilter }}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="梯度规则">
                {{ activity.rewardAlgorithm.gradientRule | gradientRuleFilter }}
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度基准">
                {{ activity.rewardAlgorithm.gradientBenchmark | gradientBenchmarkFilter }}
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度列表"/>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-table style="margin-bottom: 10px" :data="activity.rewardAlgorithm.gradientList">
                <el-table-column label="梯度" show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    梯度{{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column label="梯度指标" show-overflow-tooltip align="center" prop="quota"/>
                <el-table-column label="奖励标准" show-overflow-tooltip align="center" prop="rewardBonus"/>
              </el-table>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商品列表"/>
            </el-col>
            <el-col :span="24">
              <el-table :data="activity.products" max-height="450px">
                <el-table-column label="品牌" show-overflow-tooltip align="center" prop="parentBrand"/>
                <el-table-column label="品类" show-overflow-tooltip align="center" prop="category"/>
                <el-table-column label="商品" align="center" prop="productName"/>
                <el-table-column label="规格" show-overflow-tooltip align="center" prop="specification"/>
                <el-table-column label="售价" show-overflow-tooltip align="center" prop="retailPrice"/>
                <el-table-column label="提成" show-overflow-tooltip align="center" v-if="activity.activityType == 1"
                                 prop="simpleBonus"/>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>


    <el-dialog title="更改规则有效时间" center :visible.sync="timeRangOpen" width="400px" append-to-body>
      <div style="text-align: center; margin-bottom: 20px; margin-top: -5px"> {{ packageTimeRang.type === 1 ? packageTimeRang.packageName : '共选中' + packageIds.length + '条规则' }}</div>
      <div v-loading="rangLoading">
        <el-date-picker
          type="daterange"
          style="margin: 0 auto"
          v-model="packageTimeRang.rang"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="-"
          unlink-panels
          :editable="false"
          :clearable="false"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <div style="margin-top: 10px">仅修改截止日期：<el-checkbox v-model="packageTimeRang.isEnd"/></div>
        <div style="display: flex">
          <el-button style="margin-top: 20px" @click="timeRangOpen = false" size="small">取消</el-button>
          <el-button style="margin-top: 20px;margin-left: 240px" size="small" @click="packageTimeRangEdit">更改
          </el-button>
        </div>
      </div>
    </el-dialog>


    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="应用范围选择器"
      :visible.sync="applyDialogOpen"
      width="1500px"
      center
      @close="closeDialog"
    >

      <div style="display: flex;color: #979797" v-loading="selectorLoading">
        <div style="flex: 1;">
          <div class="title">规则详情</div>
          <el-button plain size="mini" style="float: right;color: #ed744a; border-color: #ed744a;" @click="openDetail">
            查看详情
          </el-button>
          <div style="border: 1px solid #EDEDED;border-radius: 5px;padding: 10px">
            <div>
              <span style="font-weight: 600;">规则id：</span>
              {{ dialogData.dialogPackageId }}
            </div>
            <div>
              <span style="font-weight: 600;">规则名称：</span>
              {{ dialogData.dialogPackageName }}
            </div>
            <div>
              <span style="font-weight: 600;">有效期：</span>
              {{ dialogData.dialogPackageTimeRange }}
            </div>
            <div>
              <span style="font-weight: 600;">供应商：</span>
              {{ dialogData.dialogTitle }}
            </div>
            <div>
              <span style="font-weight: 600;">品牌：</span>
              {{ dialogData.dialogBrand }}
            </div>
          </div>

          <el-row>
            <el-col :span="12">
              <div class="title">当前范围</div>
            </el-col>
            <el-col :span="12" style="margin-top: 10px"><el-button size="mini" plain style="float: right" @click="clearChooseData">清空范围</el-button></el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="color: #008AFF; font-size: 11px; line-height: 25px">*蓝色为业务员分配，橙色为网页端分配，红色为网页端高优先级分配</div>
            </el-col>
          </el-row>
          <el-scrollbar style="height: 335px; border: 1px solid #EDEDED;border-radius: 5px;">
            <el-tag
              class="tags"
              size="medium"
              v-for="tag in this.chooseData.dataPlus.templateArea"
              v-if="tag.sources === 1"
              color="#FFEFDB"
              :key="tag.item"
              style="position: relative;padding-right: 30px; border: 0"
            >
              <i class="el-icon-plus" :style="{textDecoration:(tag.exclude ? 'line-through' : 'none')}">
                {{ ' ' + tag.title + ' ' }}</i>
              <img v-if="tag.exclude" src="../assets/rubber2.svg"
                   class="tag"
                   @click="tag.exclude = !tag.exclude"
              >
              <img v-else src="../assets/rubber.svg"
                   class="tag"
                   @click="tag.exclude = !tag.exclude">
            </el-tag>

            <el-tag
              class="tags"
              size="medium"
              v-if="tag.sources === 1"
              color="#ffffff"
              v-for="tag in this.chooseData.dataMinus.templateArea"
              :key="tag.item"
              style="position: relative;padding-right: 30px;border: 1.5px solid #FFE4B5;"
            >
              <i class="el-icon-remove" :style="{textDecoration:(tag.exclude ? 'line-through' : 'none')}">
                {{ ' ' + tag.title + ' ' }}
              </i>
              <img v-if="tag.exclude" src="../assets/rubber2.svg"
                   class="tag" @click="tag.exclude = !tag.exclude">
              <img v-else src="../assets/rubber.svg"
                   class="tag" @click="tag.exclude = !tag.exclude">
            </el-tag>

            <el-tag
              class="tags"
              size="medium"
              v-for="tag in this.chooseData.dataPlus.templateArea"
              v-if="tag.sources === 2"
              :color="tag.userId ? 'rgb(242, 131, 131)':'#ecf5ff'"
              :key="tag.item"
              style="position: relative;padding-right: 30px; border: 0"
            >
              <i class="el-icon-plus" :style="{textDecoration:(tag.exclude ? 'line-through' : 'none'),color: tag.userId ?'#FFFFFF':''}">
                {{ ' ' + tag.title + ' ' }}</i>
              <img v-if="tag.exclude" src="../assets/rubber2.svg"
                   class="tag"
                   @click="tag.exclude = !tag.exclude"
              >
              <img v-else src="../assets/rubber.svg"
                   class="tag"
                   @click="tag.exclude = !tag.exclude">
            </el-tag>
            <el-tag
                    class="tags"
                    size="medium"
                    v-for="tag in this.chooseData.dataMinus.templateArea"
                    v-if="tag.sources === 2"
                    color="#ffffff"
                    :key="tag.item"
                    :style="{border: tag.userId ?'1.5px solid rgb(242, 131, 131)' : '1.5px solid #00BFFF'}"
                    style="position: relative;padding-right: 30px"
            >
                <i class="el-icon-remove" :style="{textDecoration:(tag.exclude ? 'line-through' : 'none')}">
                    {{ ' ' + tag.title + ' ' }}</i>
                <img v-if="tag.exclude" src="../assets/rubber2.svg"
                     class="tag"
                     @click="tag.exclude = !tag.exclude"
                >
                <img v-else src="../assets/rubber.svg"
                     class="tag"
                     @click="tag.exclude = !tag.exclude">
            </el-tag>
          </el-scrollbar>
        </div>

        <div style="flex: 3">
          <div style="display: flex;padding: 0 20px; justify-content: space-between">
            <div class="title" style="flex: 1">历史提成规则范围套用</div>
            <el-select v-model="templateId" placeholder="请选择" style="flex: 2"
                       value-key="label" filterable>
              <el-option
                v-for="item in historyTemplate"
                :key="item.value"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>

            <el-button type="primary" style="flex: 1;margin-left: 10px;height: 40px"
                       @click="centerDialogVisible1 = true"
                       :disabled="templateId == ''"> 清空本期修改并套用
            </el-button>
          </div>

          <el-row :gutter="20" style="padding: 10px 20px;">
            <el-col :span="4" style="width: 25%">
              <div class="title">可添加/减少范围</div>
              <el-form label-position="top" label-width="80px" :model="formArea">
                <el-form-item v-loading="loadingList.provinceLoading">
                  <el-select ref="multiSelect1" v-model="formArea.province" placeholder="省" value-key="province"
                             filterable
                             collapse-tags @change="chooseCustom"
                             clearable multiple @visible-change="getCityAndDistrict"
                             :filter-method="(item) => {dataFilter(item,'province')}"
                             :loading="loadingList.provinceLoading">
                    <div style="height: 30px">
                      <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="allProvince"
                                   v-model="checkList.checkProvince">全选
                      </el-checkbox>
                    </div>
                    <el-option
                      v-for="item in (showAllCheckOptions ? allCheckOptions : AreaList.province)"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>

                  <el-select ref="multiSelect2" v-model="formArea.city" placeholder="市" value-key="city" filterable
                             collapse-tags clearable @change="chooseCustom"
                             :no-data-text="formArea.province.length ===0 ? '请先选择省' : '无导购数据'"
                             multiple @visible-change="countDistrictData"
                             :filter-method="(item) => {dataFilter(item,'city')}" :loading="loadingList.cityLoading">
                    <div style="height: 30px">
                      <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="allCity"
                                   v-model="checkList.checkCity">
                        全选
                      </el-checkbox>
                    </div>
                    <el-option-group
                      v-for="item in (showAllCheckOptions ? allCheckOptions : AreaList.city)"
                      :key="item"
                      :label="item.province"
                      :value="item">
                      <el-option
                        v-for="value in item.city"
                        :key="value"
                        :label="value"
                        :value="value"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>

                  <el-select ref="multiSelect3" v-model="formArea.district" value-key="district" filterable
                             collapse-tags :no-data-text="formArea.city.length === 0 ? '请先选择省，市' : '无导购数据'"
                             clearable @change="chooseCustom"
                             multiple placeholder="区" @visible-change="cleanAllCheckOptions"
                             :filter-method="(item) => {dataFilter(item,'district')}"
                             :loading="loadingList.districtLoading">
                    <div style="height: 30px">
                      <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="allDistrict"
                                   v-model="checkList.checkDistrict">
                        全选
                      </el-checkbox>
                    </div>
                    <el-option-group
                      v-for="item in (showAllCheckOptions ? allCheckOptions : AreaList.district)"
                      :key="item"
                      :label="item.city"
                      :value="item">
                      <el-option
                        v-for="value in item.district"
                        :key="value"
                        :label="value"
                        :value="value"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>

                  <el-select v-model="formArea.brand" value-key="brand" filterable remote collapse-tags clearable
                             multiple placeholder="搜索连锁" :remote-method="(item) => getBrand(item)"
                             :loading="loadingList.brandLoading">
                    <div style="height: 30px">
                      <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="allBrand"
                                   v-model="checkList.checkBrand">
                        全选
                      </el-checkbox>
                    </div>
                    <el-option
                      v-for="value in AreaList.brand"
                      :key="value"
                      :label="value.brand"
                      :value="value.brand">
                    </el-option>
                  </el-select>


                  <el-select v-model="formArea.store" value-key="store" filterable collapse-tags clearable
                             multiple placeholder="门店" @visible-change="cleanAllCheckOptions"
                             :no-data-text="'请先选择连锁'"
                             :filter-method="(item) => {dataFilter(item,'store')}"
                             :loading="loadingList.storeLoading">
                    <div style="height: 30px">
                      <el-checkbox style="float: left;margin: 5px;padding-left: 15px" @change="allStore"
                                   v-model="checkList.checkStore">
                        全选
                      </el-checkbox>
                    </div>
                    <el-option-group
                      v-for="item in (showAllCheckOptions ? allCheckOptions : AreaList.store)"
                      :key="item.brand"
                      :label="item.brand"
                    >
                      <el-option
                        v-for="value in item.store"
                        :key="value"
                        :label="value"
                        :value="value">
                      </el-option>
                    </el-option-group>
                  </el-select>

                  <div style="display: flex">
                    <el-input v-model="formArea.phoneNumber" @blur="phoneChange" placeholder="请填写导购ID/手机号" class="selectBorderRadius" style="margin-bottom: 10px"/>
                    <el-button type="primary" style="border-radius: 0 4px 4px 0; height: 40px;padding: 7px 16px" @click="openSaleUpload">
                      <div style="justify-content: center;align-items: center">
                        <div style="font-size: 11px">批量</div>
                        <div style="font-size: 11px;margin-top: 3px">上传</div>
                      </div>
                    </el-button>
                  </div>

                  <div style="display: flex">
                    <el-select
                      ref="selectOptions"
                      class="selectBorderRadius"
                      v-model="searchValue4"
                      multiple
                      filterable
                      remote
                      collapse-tags
                      reserve-keyword
                      :disabled="loading"
                      placeholder="搜索标签"
                      :remote-method="queryStoreBrandId"
                      @visible-change="cleanStoreBrandInfo"
                      :loading="loading"
                      no-data-text="无匹配标签"
                      style="border-radius: 4px 0 0 4px;">
                      <el-option
                        v-for="item in supplierLabelList"
                        :key="item.propValue"
                        :label="item.propName"
                        :value="item.propValue">
                      </el-option>
                    </el-select>

                    <el-button type="primary" :disabled="loading" style="border-radius: 0 4px 4px 0; height: 40px;padding: 7px 16px" @click="openLabelUpload">
                      <div style="justify-content: center;align-items: center">
                        <div style="font-size: 11px">批量</div>
                        <div style="font-size: 11px;margin-top: 3px">上传</div>
                      </div>
                    </el-button>
                  </div>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="2"
                    style="padding-top: 110px;text-align: center;display: flex;flex-direction: column;align-items: center">
              <el-popover v-loading="loadingList.queryPackageArealoading"
                          placement="bottom-start"
                          trigger="hover">
                <div>按<span
                  style="color: #ed7043">+按钮</span>，则将左侧所选范围作为新增选项放入进本期修改当中；<br>按<span
                  style="color: #ed7043">-按钮</span>，则将左侧所选范围作为排除选项放入本期修改中；<br><span
                  style="color: #ed7043">最终应用范围：</span>当前范围框中内容+本期修改框中内容。
                </div>
                <el-button slot="reference" type="primary" style="margin-bottom: 10px;width: 40px;padding:37px 0px;"
                           icon="el-icon-plus"
                           @click="insertTag(1,formArea)"></el-button>
              </el-popover>

              <el-popover v-loading="loadingList.queryPackageArealoading"
                          placement="bottom-start"
                          trigger="hover">
                <div>按<span
                  style="color: #ed7043">+按钮</span>，则将左侧所选范围作为新增选项放入进本期修改当中；<br>按<span
                  style="color: #ed7043">-按钮</span>，则将左侧所选范围作为排除选项放入本期修改中；<br><span
                  style="color: #ed7043">最终应用范围：</span>当前范围框中内容+本期修改框中内容。
                </div>
                <el-button slot="reference" style="margin: 0;width: 40px;padding:37px 0px;border-color: #ED7043"
                           icon="el-icon-minus"
                           @click="insertTag(2,formArea)"></el-button>
              </el-popover>

              <el-popover
                style="display: block;margin-top:20px "
                placement="bottom-start"
                trigger="hover">
                <div>按<span
                  style="color: #ed7043">+按钮</span>，则将左侧所选范围作为新增选项放入进本期修改当中；<br>按<span
                  style="color: #ed7043">-按钮</span>，则将左侧所选范围作为排除选项放入本期修改中；<br><span
                  style="color: #ed7043">最终应用范围：</span>当前范围框中内容+本期修改框中内容。
                </div>
                <img src="../assets/info.svg" slot="reference">
              </el-popover>
              <!--              <i class="el-icon-question" style="margin: 0;width: 35px;padding:37px 0px;border-color: #ED7043"></i>-->
            </el-col>
            <el-col :span="18" style="width: 65%">
              <div style="display: flow">
                <div class="title">本期修改</div>
<!--                <div class="title" style="float: right">-->
<!--                  <el-checkbox v-model="cover"/>-->
<!--                  使本期修改可覆盖业务员操作-->
<!--                </div>-->
              </div>
              <el-scrollbar style="height: 335px;width: 700px; border: 1px solid #EDEDED;border-radius: 5px;">
                <el-tag
                  :class="['tags',cover ? 'tags-cover':'']"
                  size="medium"
                  :color="cover ? 'rgb(242, 131, 131)':'#FFEFDB'"
                  v-for="(tag,index) in this.chooseData.dataPlus.selectArea"
                  @close="removeTag(index,'dataPlus')"
                  :key="tag"
                  style="border: 0"
                  closable>
                  <i class="el-icon-plus" :style="{color: cover ?'#FFFFFF':''}">{{ ' ' + (tag.item || tag.title) }}</i>
                </el-tag>

                <el-tag
                  class="tags"
                  size="medium"
                  color="#ffffff"
                  v-for="(tag,index) in this.chooseData.dataMinus.selectArea"
                  @close="removeTag(index,'dataMinus')"
                  :key="tag"
                  :style="{border: cover ?'1.5px solid rgb(242, 131, 131)' : '1.5px solid #FFE4B5'}"
                  closable>
                  <i class="el-icon-minus">{{ ' ' + tag.title }}</i>
                </el-tag>

              </el-scrollbar>
            </el-col>
          </el-row>
          <div style="color: #94949D;padding: 0 20px">
            <div style="font-weight: 600; height: 30px">应用说明：</div>
            <div>导购在同一品牌中，同一时间段内，一般只有一个有效的提成规则，后分配的提成规则会覆盖掉以前的提成规则。</div>
            <div>建议先下载
              <el-link :underline="false" style="color: #008aff" @click="centerDialogVisible = true">未分配规则导购名单
              </el-link>
              ,确认应分配范围
            </div>
            <div>业务员的分配操作通常优先级高于网页端，若需使本次的网页修改可覆盖业务员的操作，请勾选本期修改右上方选项后再提交。</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row>
              <el-col :span="12">
                <div style="width: 56px;margin: 0 auto 20px">
                  <el-button plain size="mini" @click="() => {applyDialogOpen = false;localStorage.removeItem('packageId')}">取消</el-button>
                </div>
              </el-col>
              <el-col :span="12">
                <div style="width: 104px;margin: 0 auto 20px">
                  <el-button plain size="mini" :disabled="!canSubmit" @click="pushPackage"
                             :loading="loadingList.loading">确认应用
                  </el-button>
                </div>
              </el-col>
            </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="centerDialogVisible1"
      width="20%"
      center
      :show-close="false">
      <span style="font-weight: 600">确定清空本期修改并套用 “</span>{{ templateId.label }}<span
      style="font-weight: 600">” 此条历史提成范围？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="changeTemplate">确 定</el-button>
      </span>
    </el-dialog>

      <el-dialog
              :visible.sync="uploadProductPackageDialog.visible"
              width="500px"
              class="uploadDialog"
              :close-on-click-modal="false"
              center>
          <div slot="title" class="dialog-title">产品提成规则上传</div>
          <div class="content">
              <div style="text-align: center;font-size: 17px;margin-top: 20px">1、请先下载产品提成规则上传模版</div>
              <div style="text-align: center;margin-top: 20px">
                  <el-select v-model="uploadProductPackageDialog.supplierId" filterable size="small" placeholder="请选择供应商" style="margin-right: 10px">
                      <el-option
                              v-for="item in suppliers"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                      </el-option>
                  </el-select>
                  <el-button :loading="uploadProductPackageDialog.loading" type="primary" size="small" :disabled="!uploadProductPackageDialog.supplierId" @click="downloadPackageTemplate">下载模板</el-button>
              </div>
              <div style="text-align: center;font-size: 17px;margin-top: 20px">2、请设置产品提成规则生效时间</div>
              <div style="text-align: center;margin-top: 20px">
                  <el-date-picker
                          type="daterange"
                          style="margin: 0 auto"
                          v-model="uploadProductPackageDialog.rang"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          range-separator="-"
                          unlink-panels
                          :editable="false"
                          :clearable="false"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
              </div>
              <div style="text-align: center;font-size: 17px;margin-top: 20px">3、点击上传填写完成的产品提成规则</div>
              <div style="margin-top: 20px;text-align: center;">
                  <el-upload
                          :disabled="uploadProductPackageDialog.loading || !uploadProductPackageDialog.supplierId"
                          class="upload"
                          ref="uploadBatch"
                          action="#"
                          accept=".xls,.xlsx"
                          :show-file-list="false"
                          :http-request="(file) => uploadProductPackageDialog.file = file.file">
                      <div slot="trigger" class="description">
                          <i class="el-icon-plus" style="padding: 10px 20px; color: #00000066; font-size: 20px"></i>
                      </div>
                  </el-upload>
                  <div style="margin-top: 10px" v-if="uploadProductPackageDialog.file">{{uploadProductPackageDialog.file.name}}</div>
              </div>
              <div style="text-align: center; margin-top: 50px;">
                  <el-button :loading="uploadProductPackageDialog.loading" type="primary" :disabled="uploadProductPackageDialog.file === null || !uploadProductPackageDialog.supplierId || this.uploadProductPackageDialog.rang < 2" @click="uploadPackageTemplate">确定上传</el-button>
              </div>
          </div>
    </el-dialog>

    <el-dialog
      :visible.sync="uploadLabelDialog.visible"
      width="500px"
      class="uploadDialog"
      :close-on-click-modal="false"
      center>
      <div slot="title" class="dialog-title">提成规则自定义标签应用范围上传</div>
      <div class="content">
        <div style="text-align: center;font-size: 17px;margin-top: 20px">1、请先下载提成规则自定义标签应用范围上传模板</div>
        <div style="text-align: center;margin-top: 20px">
          <el-button :loading="uploadLabelDialog.loading" type="primary" size="small" @click="downloadLabelTemplate">下载模板</el-button>
        </div>
        <div style="text-align: center;font-size: 17px;margin-top: 20px">2、点击上传填写完成的提成规则自定义标签应用范围模板</div>
        <div style="margin-top: 20px;text-align: center;">
          <el-upload
            :disabled="uploadLabelDialog.loading || uploadLabelDialog.labels.length === 0"
            class="upload"
            action="#"
            accept=".xls,.xlsx"
            :show-file-list="false"
            :before-upload="beforeLabelUpload"
            :http-request="(file) => uploadLabelDialog.file = file.file">
            <div slot="trigger" class="description">
              <i class="el-icon-plus" style="padding: 10px 20px; color: #00000066; font-size: 20px"></i>
            </div>
          </el-upload>
          <div style="margin-top: 10px" v-if="uploadLabelDialog.file">{{uploadLabelDialog.file.name}}</div>
        </div>
        <div style="text-align: center; margin-top: 50px;">
          <el-button :loading="uploadLabelDialog.loading" type="primary" :disabled="!uploadLabelDialog.file || uploadLabelDialog.labels.length === 0" @click="uploadLabelTemplate">确定上传</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="uploadSaleDialog.visible"
      width="500px"
      class="uploadDialog"
      :close-on-click-modal="false"
      center>
      <div slot="title" class="dialog-title">提成规则导购应用范围上传</div>
      <div class="content">
        <div style="text-align: center;font-size: 17px;margin-top: 20px">1、请先下载导提成规则导购应用范围上传模版</div>
        <div style="text-align: center;margin-top: 20px">
          <el-button :loading="uploadSaleDialog.loading" type="primary" size="small" @click="downloadSaleTemplate">下载模板</el-button>
        </div>
        <div style="text-align: center;font-size: 17px;margin-top: 20px">2、点击上传填写完成的提成规则导购应用范围</div>
        <div style="margin-top: 20px;text-align: center;">
          <el-upload
            :disabled="uploadSaleDialog.loading"
            class="upload"
            ref="uploadBatch"
            action="#"
            accept=".xls,.xlsx"
            :show-file-list="false"
            :http-request="(file) => uploadSaleDialog.file = file.file">
            <div slot="trigger" class="description">
              <i class="el-icon-plus" style="padding: 10px 20px; color: #00000066; font-size: 20px"></i>
            </div>
          </el-upload>
          <div style="margin-top: 10px" v-if="uploadSaleDialog.file">{{uploadSaleDialog.file.name}}</div>
        </div>
        <div style="text-align: center; margin-top: 50px;">
          <el-button :loading="uploadSaleDialog.loading" type="primary" :disabled="!uploadSaleDialog.file" @click="uploadSaleTemplate">确定上传</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
    countData,
    downLoadPackageDetail, downloadPackageTemplate,
    downloadRuleTemplate,
    downloadUnassignedSale,
    getBrand,
    getCityAndDistrict,
    getHistoryTemplate,
    packageInfoQuery,
    packageInit,
    packageTimeRangEdit,
    pushPackage,
    queryExtraPropBySupplier,
    querySupplierExtraPropList,
    queryUnassignedSaleCount, uploadPackageTemplate,
    uploadRuleTemplate, useHistoryTemplate, uploadSaleTemplate
} from "@/api/package"
import selectAllOption from "@/components/selectAllOption";
import axios from 'axios'
import XLSX from 'xlsx'
import {export_json_to_excel} from "@/utils/Export2Excel";


export default {
  name: "package",
  components: {selectAllOption},
  data() {
    return {
      token: undefined,
      // 查询对象
      queryParams: {
        // pageNum: 1,// 页
        // pageSize: 10,// 每页行数
        // 输入框
        search: {
          name: 'packageName',
          value: undefined
        },
        //时间区间
        range: [],
        // 供应商id
        supplierId: undefined,
        // 品牌
        parentBrand: undefined,
        supplierName: undefined,
        parentBrandName: undefined
      },
      // 表格数据
      packages: [],
      // 表格遮罩层
      loading: false,
      // 当前账户下绑定供应商数组
      suppliers: [],
      // 当前账户可查询的品牌数据
      parentBrands: [],
      // 下载遮罩层
      downloadLoading: false,
      // 批量上传遮罩层
      uploadLoading: false,
      // 新增规则遮罩层
      savepackageLoading: false,
      // 详情弹框开关
      dialogOpen: false,
      // 规则详情
      packageVo: undefined,
      // 修改时间
      packageTimeRang: {
        packageId: undefined,
        rang: [],
        startTime: undefined,
        endTime: undefined,
        packageName: undefined,
        type: 1,
        packageIds: [],
        isEnd: false
      },
      // 修改时间弹框
      timeRangOpen: false,
      // 有效时间修改遮罩层
      rangLoading: false,
      //是否需要输出导购员信息
      includeSale: undefined,
      //应用弹框
      applyDialogOpen: false,

      dialogData: {
        dataIndex: 0,
        dialogTitle: '',//供应商名称
        dialogSupplierId: '',//供应商id
        dialogPackageId: '',//规则id
        dialogPackageName: '',//规则名称
        dialogPackageTimeRange: '',//规则有效期
        dialogBrand: ''//品牌
      },
      //选项
      AreaList: {
        province: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区'],
        city: [],
        district: [],
        districtBak: [],
        brand: [],
        store: []
      },
      //历史提成规则范围
      historyTemplate: [],
      templateId: '',
      formArea: {
        province: [],
        city: [],
        district: [],
        brand: [],
        store: [],
        phoneNumber: ''
      },
      checkList: {
        checkProvince: false,
        checkCity: false,
        checkDistrict: false,
        checkBrand: false,
        checkStore: false
      },
      loadingList: {
        loading: false,
        cityLoading: false,
        districtLoading: false,
        brandLoading: false,
        storeLoading: false,
        queryPackageArealoading: false
      },
      dataPlus: {templateArea: [], selectArea: []},
      dataMinus: {templateArea: [], selectArea: []},
      chooseData: {
        dataPlus: {templateArea: [], selectArea: []},
        dataMinus: {templateArea: [], selectArea: []}
      },
      canSubmit: false,
      allCheckOptions: [],
      showAllCheckOptions: false,
      centerDialogVisible: false,
      centerDialogVisible1: false,
      form: {
        saleArea: 1,
        day: 1,
        supplierId: []
      },
      rules: {
        saleArea: [
          {required: true, message: '请选择导购范围', trigger: 'change'}
        ]
      },
      supplierLabelList: [],
      searchValue4: [],
      searchValue: '',
      labelSearchTimer: null,
      isSelect: false,
      unassignedSaleCount: undefined, //未分配提成规则人数
      source: null,
      selectorLoading: false,
      downLoadPackageDetailLoading: false,
      uploadProductPackageDialog: {
          visible: false,
          loading: false,
          file: null,
          supplierId: null,
          rang: []
      },
      cover: true,
      packageIds: [],
      checkAll: [],
      uploadSaleDialog: {
        visible: false,
        loading: false,
        file: null
      },
      uploadLabelDialog: {
        visible: false,
        loading: false,
        file: null,
        labels: []
      },
    }
  },
  watch: {
    'formArea.province': {
      handler(newValue, oldValue) {
        this.checkList.checkProvince = newValue.length == this.AreaList.province.length && this.AreaList.province.length != 0;

        if (newValue.length === 0) {
          this.AreaList.city = [];
          this.AreaList.district = [];
          this.formArea.city = [];
          this.formArea.district = [];
          this.formArea.brand = [];
        } else {
          if (this.AreaList.city.length != 0 && this.formArea.city.length != 0) {
            for (let i = 0; i < this.AreaList.city.length;) {
              var city = this.AreaList.city[i];
              if (newValue.indexOf(city.province) == -1) {
                this.AreaList.city.splice(i, 1);
                this.formArea.city = this.formArea.city.filter(item => city.city.indexOf(item) == -1);
              } else {
                i++;
              }
            }
          }
        }

        //如果添加了数据则取消城市的全选状态
        if (newValue.length > oldValue.length && this.checkList.checkCity)
          this.checkList.checkCity = false;

      }
    },
    'formArea.city': {
      handler(newValue, oldValue) {
        this.AreaList.district = JSON.parse(this.AreaList.districtBak);

        if (this.AreaList.city.length != 0) {
          var length = 0;
          this.AreaList.city.forEach(item => {
            length += item.city.length;
          })
          this.checkList.checkCity = newValue.length == length;
        }

        if (newValue.length == 0) {
          this.AreaList.district = [];
          this.formArea.district = [];
          this.formArea.brand = [];
          this.checkList.checkCity = false;
        } else {
          if (this.AreaList.district.length != 0 && this.formArea.district.length != 0) {
            for (let i = 0; i < this.AreaList.district.length;) {
              var district = this.AreaList.district[i];
              if (newValue.indexOf(district.city) == -1) {
                this.AreaList.district.splice(i, 1);
                this.formArea.district = this.formArea.district.filter(item => district.district.indexOf(item) == -1);
              } else {
                i++;
              }
            }
          }

          //如果添加了数据则取消区的全选状态
          if (newValue.length > oldValue.length && this.checkList.checkDistrict)
            this.checkList.checkDistrict = false;
        }
      }
    },
    'formArea.district': {
      handler(newValue, oldValue) {
        if (this.AreaList.district.length != 0) {
          var length = 0;
          this.AreaList.district.forEach(item => {
            length += item.district.length;
          })
          this.checkList.checkDistrict = newValue.length == length
        }

        if (newValue.length == 0) {
          this.formArea.brand = [];
          this.checkList.checkDistrict = false;
        }
      }
    },
    'formArea.brand': {
      handler(newValue, oldValue) {
        if (this.AreaList.brand.length !== 0 && newValue.length !== 0) {
          this.checkList.checkBrand = newValue.filter(item => this.AreaList.brand.map(item => item.brand).indexOf(item) !== -1).length === this.AreaList.brand.length
        }

        if (newValue.length === 0) {
          this.checkList.checkBrand = false;
          this.checkList.checkStore = false;
          this.formArea.store = [];
          this.AreaList.store = [];
        } else {
          if (this.formArea.store.length !== 0) {
            for (let i = 0; i < this.AreaList.store.length;) {
              var store = this.AreaList.store[i];
              if (newValue.indexOf(store.brand) === -1) {
                this.AreaList.store.splice(i, 1);
                this.formArea.store = this.formArea.store.filter(item => store.store.indexOf(item) === -1);
              } else {
                i++;
              }
            }
          } else {
            this.AreaList.store = Array.from(new Set([...this.AreaList.store, ...this.AreaList.brand.filter(item => newValue.indexOf(item.brand) !== -1)]));
          }
        }
      }
    },
    'formArea.store': {
      handler(newValue, oldValue) {
        if (this.AreaList.store.length != 0) {
          var store = [];
          this.AreaList.store.forEach(item => store = [...item.store, ...store]);
          this.checkList.checkStore = newValue.length == store.length;
        } else if (this.AreaList.store.length == 0 || newValue.length == 0) {
          this.checkList.checkStore = false
        }
      }
    },
    'queryParams.supplierName': {
      handler(newValue, oldValue) {
        if (newValue == null || newValue == "")
          this.$refs.el_auto.activated = true

      }
    },
    chooseData: {
      handler(newValue, oldValue) {
        this.canSubmit = this.chooseData.dataPlus.templateArea.length != 0 || this.chooseData.dataPlus.selectArea.length != 0 || this.chooseData.dataMinus.templateArea.length != 0 || this.chooseData.dataMinus.selectArea.length != 0;
      },
      deep: true
    },
    centerDialogVisible: {
      handler(newValue, oldValue) {
        //关闭dialog清空数据
        this.form = {
          saleArea: 1,
          day: 1,
          supplierId: []
        }
        this.unassignedSaleCount = undefined;
      }
    }
  },
  methods: {
    queryParentBrand(queryString, cb) {
      var parentBrands = this.parentBrands
      var results = queryString ? parentBrands.filter(this.createFilter(queryString)) : parentBrands;
      cb(results)
    },

    querySupplier(queryString, cb) {
      var suppliers = this.suppliers;
      if (queryString == '') {
        cb(suppliers);
        return
      }
      var results = queryString ? suppliers.filter(this.createFilter(queryString)) : suppliers;
      cb(results)
    },

    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },

    // 重置按钮操作
    resetQuery(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    // 供应商选框改变
    supplierChange(item) {
      this.queryParams.supplierId = item.id
      this.queryParams.supplierName = item.name
      if (!this.queryParams.supplierId)
        this.queryParams.parentBrand = undefined
      else {
        let sup = this.queryParams.supplierId
        this.parentBrands = this.suppliers.find(s => s.id == sup).children
        this.queryParams.parentBrand = undefined
      }
    },
    parentBrandChange(item) {
      this.queryParams.parentBrand = item.name
    },
    // 规则查询
    handleQuery() {
      if (this.queryParams.search.name != 'saleId' && !this.queryParams.supplierId) {
        this.$notify.error({
          title: '错误',
          message: '未选择供应商！',
          position: 'bottom-right'
        })
        return
      }
      let param = {
        name: this.queryParams.search.name,
        value: this.queryParams.search.value,
        start: undefined,
        end: undefined,
        supplierId: this.queryParams.supplierId,
        parentBrand: this.queryParams.parentBrand,
      }

      if (this.queryParams.range && this.queryParams.range.length == 2) {
        param.start = this.queryParams.range[0]
        param.end = this.queryParams.range[1]
      }
      this.loading = true
      this.dialogData.dialogSupplierId = this.queryParams.supplierId;
      this.dialogData.dialogTitle = this.queryParams.supplierName;
      this.resetForm();

      let packageId = localStorage.getItem('packageId')
      packageInfoQuery(param, this.token).then(({data}) => {
          this.packages = data.date.map(item => {
            item.parentBrand = item.parentBrand.split(",")
            item['checked'] = []
            this.formatPackageTime(item)
            return item
          })
          this.packageIds = []
          this.checkAll = []
          //若是从添加规则页面跳转过来的则，默认第一条规则
          const index = this.packages.findIndex(s => s.packageId == packageId)
          if (index >= 0){
              this.applyDialogOpened(index);
          }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.loading = false)
    },
    // 前往新增规则页面
    toSavepackage() {
      this.$router.push({path: '/SavePackage'})
    },
    // 前往编辑规则页面
    toEditPackage(packageInfo) {
      localStorage.setItem('queryParams', JSON.stringify(this.queryParams));
      this.$router.push({path: '/EditPackage', query: {packageInfo:encodeURIComponent(JSON.stringify(packageInfo))}})
    },
    dialogOpened(aPackage) {
      this.dialogOpen = true
      this.packageVo = aPackage
    },
    // 详情弹框关闭
    dialogClose() {
      this.dialogOpen = false
      this.packageVo = undefined
    },
    // 有效时间修改弹框打开
    timeRangOpened(packageVo) {
      this.timeRangOpen = true
      this.packageTimeRang.packageIds = []
      if (packageVo) {
        this.packageTimeRang.packageId = packageVo.packageId
        this.packageTimeRang.packageName = packageVo.packageName
        this.packageTimeRang.rang = [packageVo.startTime, packageVo.endTime]
        this.packageTimeRang.isEnd = false
        this.packageTimeRang.type = 1
      } else if (this.packageIds.length > 0) {
        packageVo = this.packages.find(item => item.packageId == this.packageIds[0])
        this.packageTimeRang.type = 2
        this.packageTimeRang.isEnd = true
        this.packageTimeRang.rang = [packageVo.startTime, packageVo.endTime]
      }
    },
    closeDialog() {
      this.applyDialogOpen = false;
      localStorage.removeItem('packageId')
      this.resetForm();
    },
    resetForm() {
      this.formArea = {
        province: [],
        city: [],
        district: [],
        brand: [],
        store: [],
        phoneNumber: ''
      }
      this.searchValue4 = []

      this.chooseData = {
        dataPlus: {templateArea: [], selectArea: []},
        dataMinus: {templateArea: [], selectArea: []}
      }

      this.dataPlus = {templateArea: [], selectArea: []};
      this.dataMinus = {templateArea: [], selectArea: []};

      this.templateId = '';
      // this.$refs[form].clearValidate();
    },
    //点击应用打开dialog
    applyDialogOpened(index) {
      this.dialogData.dataIndex = index;
      this.dialogData.dialogPackageId = this.packages[index].packageId
      this.dialogData.dialogPackageName = this.packages[index].packageName
      this.dialogData.dialogPackageId = this.packages[index].packageId
      this.dialogData.dialogPackageTimeRange = this.packages[index].startTime + "~" + this.packages[index].endTime
      this.dialogData.dialogBrand = this.packages[index].parentBrand
      this.dialogData.dialogSupplierId = this.packages[index].supplierId
      this.dialogData.dialogTitle = this.packages[index].supplierName
      this.applyDialogOpen = true;
      this.cover = true

      this.selectorLoading = true;
      getHistoryTemplate(this.token, this.dialogData.dialogSupplierId, this.dialogData.dialogPackageId).then(res => {
        if (res.data.code === 200 && res.data.data.length !== 0) {
          var templateList = res.data.data;
          this.$set(this, 'historyTemplate', templateList);
          templateList.filter(item => item.packageId == this.dialogData.dialogPackageId).forEach(item => {
            this.chooseData.dataPlus.templateArea = item.title.operate1;
            this.chooseData.dataMinus.templateArea = item.title.operate0;
            // this.dataPlus.templateArea = [...this.dataPlus.templateArea, ...item.title[1]]
            // this.dataMinus.templateArea = [...this.dataMinus.templateArea, ...item.title[0]]
          })
        }

        if (res.data.code === 0) {
          this.$message.error("历史提成规则范围获取失败");
        }
      }).catch(() => this.$message.error("历史提成规则范围获取失败"))
        .finally(() => this.selectorLoading = false);
    },
    changeTemplate() {
      //todo promise
      if (this.templateId.title == null) {
        this.selectorLoading = true;
        let sources = this.cover ? '2': ''
        useHistoryTemplate(this.token, this.dialogData.dialogSupplierId,this.dialogData.dialogPackageId, this.templateId.packageId,sources).then(res => {
          if (res.data.code === 200 && res.data.data.length !== 0) {
            getHistoryTemplate(this.token, this.dialogData.dialogSupplierId, this.dialogData.dialogPackageId).then(res => {
              if (res.data.code === 200 && res.data.data.length !== 0) {
                var templateList = res.data.data;
                this.$set(this, 'historyTemplate', templateList);
                templateList.filter(item => item.packageId == this.dialogData.dialogPackageId).forEach(item => {
                  this.chooseData.dataPlus.templateArea = item.title.operate1;
                  this.chooseData.dataMinus.templateArea = item.title.operate0;
                })
              }

              if (res.data.code === 0) {
                this.$message.error("历史提成规则范围获取失败");
              }
            }).catch(() => this.$message.error("历史提成规则范围获取失败"))
              .finally(() => {
                this.selectorLoading = false
                this.$message.success("套用成功");
              });
          }

          if (res.data.code === 0) {
            this.$message.error("套用历史提成范围失败");
          }
        }).finally(() => {
          // this.selectorLoading = false;

        })
      } else {
        this.chooseData.dataPlus.selectArea = this.templateId.title.operate1;
        this.chooseData.dataMinus.selectArea = this.templateId.title.operate0;
        this.$message.success("套用成功");
      }

      this.centerDialogVisible1 = false;
    },
    //获取市和区数据 true:打开 false:关闭
    getCityAndDistrict(item) {
      this.cleanAllCheckOptions();

      //关闭后查询市区数据
      if (!item && this.formArea.province.length != 0) {
        this.loadingList.cityLoading = true;
        this.loadingList.districtLoading = true;
        var param = {
          'supplierId': this.dialogData.dialogSupplierId,
          'province': this.formArea.province
        }
        getCityAndDistrict(this.token, param).then(res => {
          if (res.data.code === 200) {
            this.$set(this.AreaList, 'city', res.data.date.city);
            this.$set(this.AreaList, 'districtBak', JSON.stringify(res.data.date.district));
            this.$set(this.AreaList, 'district', res.data.date.district);
          }
        }).finally(() => {
          this.loadingList.cityLoading = false;
          this.loadingList.districtLoading = false;
        })
      }
    },
    cleanAllCheckOptions() {
      this.allCheckOptions = [];
      this.showAllCheckOptions = false;
    },
    countDistrictData(result) {
      this.cleanAllCheckOptions();

      if (!result) {
        this.$set(this.AreaList, 'district', this.AreaList.district.filter(item => this.formArea.city.indexOf(item.city) != -1))
      }
    },
    getBrand(item) {
      var time = item ? 200 : 0;
      if (item) {
        setTimeout(() => {
          this.loadingList.brandLoading = true

          var parma = {
            'supplierId': this.dialogData.dialogSupplierId,
            'brand': item
          }

          getBrand(this.token, parma).then(res => {
            if (res.data.code == 200) {
              this.$set(this.AreaList, 'brand', res.data.date.brand)
              this.checkList.checkBrand = this.formArea.brand.filter(item => this.AreaList.brand.map(item => item.brand).indexOf(item) !== -1).length === this.AreaList.brand.length
            }
          }).finally(() => {
            this.loadingList.brandLoading = false;
          })
        }, time);
      }
    },

    allProvince(item) {
      if (item) {
        this.formArea.province = this.allCheckOptions.length != 0 ? this.allCheckOptions : this.AreaList.province;
      } else {
        this.formArea.province = [];
      }
    },
    allCity(item) {
      this.formArea.city = [];
      if (item) {
        if (this.allCheckOptions.length == 0) {
          this.AreaList.city.forEach(item => {
            item.city.forEach(cityItem => {
              this.formArea.city.push(cityItem)
            })
          })
        } else {
          this.allCheckOptions.forEach(item => {
            item.city.forEach(cityItem => {
              this.formArea.city.push(cityItem)
            })
          })
        }
      } else {
        this.formArea.city = [];
      }
    },
    allDistrict(item) {
      this.formArea.district = [];
      if (item) {
        if (this.allCheckOptions.length == 0) {
          this.AreaList.district.forEach(item => {
            item.district.forEach(districtItem => {
              this.formArea.district.push(districtItem)
            })
          })
        } else {
          this.allCheckOptions.forEach(item => {
            item.district.forEach(districtItem => {
              this.formArea.district.push(districtItem)
            })
          })
        }
      } else {
        this.formArea.district = [];
      }
    },
    allBrand(item) {
      if (item) {
        this.formArea.brand = Array.from(new Set([...this.formArea.brand, ...this.AreaList.brand.map(item => item.brand)]));
      } else {
        this.formArea.brand = this.formArea.brand.filter(x => !this.AreaList.brand.map(item => item.brand).some(y => y === x));
      }
    },
    allStore(item) {
      if (item) {
        var store = [];

        if (this.allCheckOptions.length != 0) {
          this.allCheckOptions.forEach(item => store = [...store, ...item.store]);
        } else {
          this.AreaList.store.forEach(item => store = [...item.store, ...store]);
        }

        this.formArea.store = store;
      } else {
        this.formArea.store = [];
      }
    },
    phoneChange() {
      if (this.formArea.phoneNumber.length > 11)
        this.formArea.phoneNumber = this.formArea.phoneNumber.substr(0, 11);

      //如果依赖element的表单校验，就到这里就OK了，如果单单用了el-input不用element的表单校验，那继续往下
      var reg = /^1[3456789]\d{9}$/;
      if (this.formArea.phoneNumber.length == 11 && !reg.test(this.formArea.phoneNumber)) {
        this.$message.error('请输入正确格式的手机号码');
      }
    },
    message(type, message) {
      if (type) {
        if (document.getElementsByClassName('el-message').length === 0)
          this.$message.success(message);
      } else {
        if (document.getElementsByClassName('el-message').length === 0)
          this.$message.error(message);
      }
    },
    //1:加 2:减
    insertTag(type, formArea) {
      if (formArea.province.length == 0 && formArea.brand.length == 0 && formArea.phoneNumber == '' && formArea.store.length == 0 && this.searchValue4.length == 0) {
        this.$message.error('请先选择范围');
        return;
      }

      var phoneReg = /^1[3456789]\d{9}$/;
      var pattern = /^\d{6}$/;
      if ((formArea.phoneNumber.length === 11 && !phoneReg.test(formArea.phoneNumber)) || (formArea.phoneNumber.length === 6 && !pattern.test(formArea.phoneNumber))) {
        this.$notify.error({
          title: '错误',
          message: '请输入正确的导购ID/手机号',
          position: 'bottom-right'
        })
        return;
      }

      if (formArea.province.length !== 0 || formArea.city.length !== 0 || formArea.district.length !== 0 || formArea.brand.length !== 0 || (formArea.phoneNumber !== null && formArea.phoneNumber !== '') || formArea.store.length !== 0 || this.searchValue4.length !== 0) {
        this.loadingList.loading = true
        this.loadingList.queryPackageArealoading = true;

        formArea.searchTitle = this.searchValue4;

        countData(this.token, formArea, this.dialogData.dialogSupplierId).then(res => {
          if (res.data.code == 1) {
            return this.$message.error('未查询到该导购信息，请确认数据是否正确');
          }

          if (res.data.code == 200) {
            if (type === 1) {
              this.chooseData.dataPlus.selectArea = [...this.chooseData.dataPlus.selectArea, ...res.data.date];
            } else {
              this.chooseData.dataMinus.selectArea = [...this.chooseData.dataMinus.selectArea, ...res.data.date];
            }
            if (document.getElementsByClassName('el-message').length === 0)
              this.$message.success('添加成功');

            this.formArea = {
              province: [],
              city: [],
              district: [],
              brand: [],
              store: [],
              phoneNumber: ''
            }
          }
        }).catch(error => {
          this.$message.error('添加失败,请联系客服');
        }).finally(() => {
          this.loadingList.loading = false
          this.loadingList.queryPackageArealoading = false;
        })
      }

      if (this.value.length != 0) {
        var storeBrandSaleId = []
        this.value.forEach(item => storeBrandSaleId = [...storeBrandSaleId, ...item])

        if (type === 1) {
          this.dataPlus.selectArea = Array.from(new Set([...this.dataPlus.selectArea, ...storeBrandSaleId]));
          storeBrandSaleId.forEach(item => {
            this.chooseData.dataPlus.selectArea.push({
              province: [],
              city: [],
              district: [],
              brand: [],
              store: [],
              phoneNumber: item
            });
          })
        } else {
          this.dataMinus.selectArea = Array.from(new Set([...this.dataMinus.selectArea, ...storeBrandSaleId]));
          storeBrandSaleId.forEach(item => {
            this.chooseData.dataMinus.selectArea.push({
              province: [],
              city: [],
              district: [],
              brand: [],
              store: [],
              phoneNumber: item
            });
          })
        }
        this.value = [];
      }
    },
    //删除范围
    removeTag(index, type) {
      this.chooseData[type].selectArea.splice(index, 1);
      this.$message.success('删除成功');
    },
    //清空选择范围数据
    clearChooseData() {
      this.chooseData.dataPlus.templateArea.forEach(item => item.exclude = true)
      this.chooseData.dataMinus.templateArea.forEach(item => item.exclude = true)
    },
    //确认应用
    pushPackage() {
      var chooseData = JSON.parse(JSON.stringify(this.chooseData));
      var dataPlus = chooseData.dataPlus;
      let dataCover = []

      if (dataPlus.selectArea.length !== 0) {
        for (let i = 0; i < dataPlus.selectArea.length;) {
          var title = dataPlus.selectArea[i].title;
          let data = dataPlus.templateArea.find(item => item.title == title)
          if (data) {
            if (this.cover && data.sources == '1' && data.ruleId) {
              dataCover.push(data.ruleId)
            }
            dataPlus.selectArea.splice(i, 1);
            continue;
          }
          i++;
        }
      }

      var dataMinus = chooseData.dataMinus;
      if (dataMinus.selectArea.length !== 0) {
        for (let i = 0; i < dataMinus.selectArea.length;) {
          var title = dataMinus.selectArea[i].title;
          let data = dataMinus.templateArea.find(item => item.title == title)
          if (data) {
            if (this.cover && data.sources == '1' && data.ruleId) {
              dataCover.push(data.ruleId)
            }
            dataMinus.selectArea.splice(i, 1);
            continue;
          }
          i++;
        }
      }

      var dataList = {
        'dataJson': chooseData,
        'dataCover': dataCover,
        'supplierId': this.dialogData.dialogSupplierId,
        'packageInfo': {
          'packageId': this.packages[this.dialogData.dataIndex].packageId,
          'startTime': this.packages[this.dialogData.dataIndex].startTime,
          'endTime': this.packages[this.dialogData.dataIndex].endTime
        },
        cover: this.cover
      }
      this.loadingList.loading = true
      pushPackage(this.token, dataList).then(res => {
        if (res.data.code == 200) {
          this.$notify.success({
            title: '成功',
            message: '应用成功',
            position: 'bottom-right'
          })
          this.$message.success("发布成功")
          this.applyDialogOpen = false;
          localStorage.removeItem('packageId')
        } else {
          this.$message.error(res.data.msg);
        }
      }).finally(() => this.loadingList.loading = false)
    },
    // 修改规则有效时间
    packageTimeRangEdit() {
      this.rangLoading = true
      const type = this.packageTimeRang.type
      this.packageTimeRang.startTime = this.packageTimeRang.isEnd ? null : this.packageTimeRang.rang[0]
      this.packageTimeRang.endTime = this.packageTimeRang.rang[1]
      this.packageTimeRang.packageIds = this.packageIds
      packageTimeRangEdit(this.packageTimeRang, this.token).then(({data}) => {
        let {code, msg} = data
        if (code == 200) {
          this.$notify.success({
            title: '修改成功',
            message: msg,
            position: 'bottom-right'
          })
          this.timeRangOpen = false
          if (type === 2) {
            this.packages.forEach(item => {
              if (this.packageIds.some(packageId => packageId == item.packageId)) {
                item.startTime = this.packageTimeRang.isEnd ? item.startTime : this.packageTimeRang.startTime
                item.endTime = this.packageTimeRang.endTime
                item.checked = []
                this.formatPackageTime(item)
              }
            })
            this.packageIds = []
            this.checkAll = []
          } else {
            let find = this.packages.find(p => this.packageTimeRang.packageId == p.packageId);
            find.startTime = this.packageTimeRang.isEnd ? find.startTime : this.packageTimeRang.startTime
            find.endTime = this.packageTimeRang.endTime
            this.formatPackageTime(find)
          }
        } else {
          this.$notify.error({
            title: '错误',
            message: msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.rangLoading = false)
    },


    // 下载应用范围模板
    downloadRuleTemplate() {
      if (!this.queryParams.supplierId || !this.queryParams.supplierName) {
        this.$notify.error({
          title: '错误',
          message: '未选择供应商！',
          position: 'bottom-right'
        })
        return;
      }

      if (this.includeSale == null) {
        this.$notify.error({
          title: '错误',
          message: '请选择应用分配表格范围！',
          position: 'bottom-right'
        })
        return;
      }

      var range = this.queryParams.range;
      if (range == '') {
        range = 'undefined';
      }
      this.downloadLoading = true
      let param = {
        name: this.queryParams.search.name,
        value: this.queryParams.search.value,
        start: undefined,
        end: undefined,
        supplierId: this.queryParams.supplierId,
        parentBrand: this.queryParams.parentBrand,
        includeSale: this.includeSale
      }
      if (this.queryParams.range && this.queryParams.range.length == 2) {
        param.start = this.queryParams.range[0]
        param.end = this.queryParams.range[1]
      }
      downloadRuleTemplate(this.token, param).then(res => {
        if (res.data) {
          this.handleDownload(res)
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '下载失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.downloadLoading = false)
    },

    uploadRuleOpen() {
      this.$refs.uploadRuleTemplate.click()
    },
    // 上传应用范围
    uploadRule() {
      this.uploadLoading = true
      let inputDOM = this.$refs.uploadRuleTemplate
      let file = inputDOM.files[0]
      let formData = new FormData()
      formData.append("file", file)
      uploadRuleTemplate(this.token, formData).then(({data}) => {
        let {code, msg} = data
        if (code == 200) {
          this.$notify.success({
            title: '上传',
            message: '应用范围上传成功',
            position: 'bottom-right'
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '上传失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.uploadLoading = false
        this.$refs.uploadRuleTemplate.value = ''
      })
    },
    handleDownload(res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    chooseCustom() {
      setTimeout(() => {
        this.$refs.multiSelect1.blur()
        this.$refs.multiSelect2.blur()
        this.$refs.multiSelect3.blur()
      }, 50)
    },
    dataFilter(val, type) {
      this.showAllCheckOptions = this.allCheckOptions.length != 0 && (val != null || val != '');
      var options = [];
      if (val) {
        switch (type) {
          case 'province':
            options = this.AreaList.province;
            this.$set(this, 'allCheckOptions', options.filter(item => {
              return item.indexOf(val) != -1;
            }));
            break;
          case 'city':
            options = JSON.parse(JSON.stringify(this.AreaList.city));
            this.$set(this, 'allCheckOptions', options.filter(item => {
              item.city = item.city.filter(cityItem => {
                return cityItem.indexOf(val) != -1;
              });
              return item.city.length != 0;
            }));
            break;
          case 'district':
            options = JSON.parse(JSON.stringify(this.AreaList.district));
            this.$set(this, 'allCheckOptions', options.filter(item => {
              item.district = item.district.filter(districtItem => {
                return districtItem.indexOf(val) != -1;
              });
              return item.district.length != 0;
            }));
            break;
          case 'store':
            options = JSON.parse(JSON.stringify(this.AreaList.store));
            this.$set(this, 'allCheckOptions', options.filter(item => {
              item.store = item.store.filter(storeItem => storeItem.indexOf(val) != -1);
              return item.store.length != 0;
            }));
            break;
        }

        this.showAllCheckOptions = true;
      } else {
        this.cleanAllCheckOptions();
      }
    },
    downloadUnassignedSale() {
      this.downloadLoading = true;

      const source = axios.CancelToken.source()
      this.source = source;
      downloadUnassignedSale(this.token, this.form, source.token).then(res => {
        if (res == null) {
          this.$message.error('取消下载');
        } else {
          this.handleDownload(res)
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '下载失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.downloadLoading = false)
    },
    cancelDownloadUnassignedSale() {
      this.centerDialogVisible = false;
      this.source.cancel('取消请求');
    },
    queryUnassignedSaleCount() {
      console.log(this.queryParams.supplierId)
      if (!this.queryParams.supplierId) {
        return this.$message.error('请先选择供应商');
      }
      this.savepackageLoading = true;
      queryUnassignedSaleCount(this.token, this.queryParams.supplierId).then(res => {
        if (res.data.code == 200) {
          this.unassignedSaleCount = res.data.date;
        } else {
          this.$notify.error({
            title: '错误',
            message: res.data.msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请稍后重试',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.savepackageLoading = false)
    },
    queryStoreBrandId(query) {
      this.searchValue = query
      clearTimeout(this.labelSearchTimer)
      if (!query || !query.trim()) {
        this.supplierLabelList = []
        this.loading = false
        return
      }
      this.labelSearchTimer = setTimeout(() => this.searchOptions(query), 300)
    },
    searchOptions(inputValue = this.searchValue) {
      this.loading = true
      var param = {
        inputValue: inputValue.trim(),
        supplierId: this.dialogData.dialogSupplierId,
        size: 100
      }
      querySupplierExtraPropList(this.token, param).then(res => {
        if (res.data.code === 1) {
          this.$message.error("查询失败，请稍后重试")
        } else {
          this.$set(this, 'supplierLabelList', res.data.date)
        }
      }).finally(() => this.loading = false)
    },
    cleanStoreBrandInfo(visible) {
      if (!visible) this.supplierLabelList = [];
    },
    supplierFilter(inputValue) {
      this.$set(this, 'allCheckOptions', this.suppliers.filter(item => item.name.indexOf(inputValue) != -1));
    },
    openDetail() {
      console.log(this.dialogData.dialogPackageId);
      this.dialogOpened(this.packages.filter(item => item.packageId == this.dialogData.dialogPackageId)[0])
    },
    //下载规则详情表格
    downLoadPackageDetail() {
      // let xlsxParam = {raw: true};
      // let wb = XLSX.utils.table_to_book(document.querySelector("#table"), xlsxParam);
      //
      // const wbout = XLSX.write(wb, {
      //   bookType: "xlsx",
      //   bookSST: true,
      //   type: "array"
      // });

      // try {
      //   FileSaver.saveAs(new Blob([wbout], {type: "application/octet-stream"}), "file-name.xlsx");
      // } catch (e) {
      //   if (typeof console !== "undefined")
      //     console.log(e, wbout);
      // }

      this.downLoadPackageDetailLoading = true;
      var packageName = this.packageVo.packageName;
      var activityName = this.packageVo.activitys[0].activityName;
      var startTime = this.packageVo.startTime;
      var endTime = this.packageVo.endTime;
      var parentBrand = this.packageVo.parentBrand.join(',')
      var products = this.packageVo.activitys[0].products;
      var packageDescription = this.packageVo.packageDescription

      var dataParam = {
        packageName, activityName, startTime, endTime, products,
        parentBrand, packageDescription
      }
      downLoadPackageDetail(this.token, dataParam).then(res => {
        if (res) {
          this.handleDownload(res)
          this.$notify.success({
            title: '成功',
            message: '导出成功',
            position: 'bottom-right'
          })
        }
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '导出失败，请联系管理员',
          position: 'bottom-right'
        })
      }).finally(() => this.downLoadPackageDetailLoading = false)
    },
      //打开产品提成规则上传弹框
    openUploadPackage() {
        this.uploadProductPackageDialog = {
            visible: true,
            loading: false,
            file: null,
            supplierId: this.suppliers.length === 1 ? this.suppliers[0].id : null,
            rang: []
        }
    },
    //套用规则
    copyPackage(packageInfo) {
        this.$router.push({path: '/SavePackage', query: {packageInfo:encodeURIComponent(JSON.stringify(packageInfo))}});
    },
      //下载规则模板
    downloadPackageTemplate() {
      this.uploadProductPackageDialog.loading = true;
      downloadPackageTemplate(this.token, this.uploadProductPackageDialog.supplierId).then(res => {
          if (res.data) {
              this.handleDownload(res)
          }
      }).finally(() => this.uploadProductPackageDialog.loading = false)
    },
      //上传规则模板
    uploadPackageTemplate() {
        if (this.uploadProductPackageDialog.rang.length < 2) {
            this.$notify.warning({
                title: '提示',
                message: '未选择提成规则生效时间',
                position: 'bottom-right'
            })
            return
        }
        let formData = new FormData()
        formData.append("file", this.uploadProductPackageDialog.file)
        formData.append("supplierId", this.uploadProductPackageDialog.supplierId)
        formData.append("startDate", this.uploadProductPackageDialog.rang[0])
        formData.append("endDate", this.uploadProductPackageDialog.rang[1])
        this.uploadProductPackageDialog.loading = true
        uploadPackageTemplate(this.token,formData).then(res => {
          if (res.data.code === 1) {
                this.$notify.error({
                    title: '失败',
                    message: res.data.msg,
                    position: 'bottom-right'
                })
            } else {
                this.$notify.success({
                    title: '成功',
                    message: res.data.msg,
                    position: 'bottom-right'
                })
                this.uploadProductPackageDialog.visible = false;
                this.queryParams.supplierId = this.uploadProductPackageDialog.supplierId
                this.handleQuery();
            }
        }).finally(() => this.uploadProductPackageDialog.loading = false)
    },
    checkedClick: function (val,packageId,index) {
      if (val.length === 0) {
        this.packageIds = this.packageIds.filter(it => it !== packageId)
        this.packages[index].checked = []
        this.checkAll = []
      } else {
        this.packageIds.push(packageId)
        if (this.packageIds.length === this.packages.length) {
          this.checkAll = ['0']
        }
      }
    },
    checkedClickAll: function (val) {
      if (val && val.length > 0) {
        this.packageIds = this.packages.map(it => it.packageId)
        this.packages.forEach(item => item.checked = ['0'])
      } else {
        this.packageIds = []
        this.packages.forEach(item => item.checked = [])
      }
      console.log(this.packageIds)
      console.log(this.packages)
    },
    formatPackageTime: function (item) {
      const endDate = new Date(item.endTime);
      const now = new Date();
      let monthRange = '';
      let monthRangeColor = '';
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const nextMonthDate = new Date(now);
      nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
      const nextYear = nextMonthDate.getFullYear();
      const nextMonth = nextMonthDate.getMonth();
      if (endDate.getFullYear() === currentYear && endDate.getMonth() === currentMonth) {
        monthRange = '本月到期';
        monthRangeColor = 'red';
      }
      else if (endDate.getFullYear() === nextYear && endDate.getMonth() === nextMonth) {
        monthRange = '次月到期';
        monthRangeColor = '#ff9300';
      }
      item['monthRange'] = monthRange;
      item['monthRangeColor'] = monthRangeColor;
    },
    openLabelUpload() {
      this.uploadLabelDialog = {
        visible: true,
        loading: true,
        file: null,
        labels: []
      }
      queryExtraPropBySupplier(this.token, this.dialogData.dialogSupplierId).then(({data}) => {
        if (data.code === 200) {
          const labels = Array.isArray(data) ? data : (data.date || data.data || [])
          this.uploadLabelDialog.labels = [...labels.reduce((map, item) => {
            const current = map.get(item.name)
            if (!current || item.id > current.id) {
              map.set(item.name, item)
            }
            return map
          }, new Map()).values()];
        } else {
          this.uploadLabelDialog.labels = []
        }
      }).finally(() => this.uploadLabelDialog.loading = false)
    },
    downloadLabelTemplate() {
      const labels = this.uploadLabelDialog.labels
      if (labels.length === 0) {
        return this.$notify.warning({
          title: '提示',
          message: '无自定义标签，无法下载',
          position: 'bottom-right'
        })
      }
      export_json_to_excel({
        header: labels.map(item => item.name),
        data: [],
        filename: '提成规则自定义标签应用范围上传模板',
        autoWidth: true,
        bookType: 'xlsx'
      })
    },
    readLabelTemplate(file, labels) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = event => {
          try {
            const workbook = XLSX.read(event.target.result, {type: 'array'})
            const sheet = workbook.Sheets[workbook.SheetNames[0]]
            const rows = XLSX.utils.sheet_to_json(sheet, {header: 1, defval: null, raw: false})
            const headers = rows[0] || []
            const data = []
            const seen = new Set()
            headers.forEach((header, index) => {
              const label = labels.find(item => String(item.name).trim() === String(header || '').trim())
              if (!label) return
              rows.slice(1).forEach(row => {
                const cell = row[index]
                if (cell === null || cell === undefined) return
                const value = String(cell).trim()
                const uniqueKey = JSON.stringify([String(label.name).trim(), value])
                if (value === '' || seen.has(uniqueKey)) return
                seen.add(uniqueKey)
                data.push({
                  item: value + '(' + label.name + ')',
                  data: {
                    type: label.id,
                    typeName: label.name,
                    typeValue: value
                  }
                })
              })
            })
            resolve(data)
          } catch (error) {
            reject(new Error('模板解析失败，请确认文件格式正确'))
          }
        }
        reader.onerror = () => reject(new Error('模板读取失败'))
        reader.readAsArrayBuffer(file)
      })
    },
    beforeLabelUpload(file) {
      const isWithinLimit = file.size <= 5 * 1024 * 1024
      if (!isWithinLimit) {
        this.$notify.error({
          title: '错误',
          message: '上传的自定义标签文件不能超过5MB',
          position: 'bottom-right'
        })
      }
      return isWithinLimit
    },
    uploadLabelTemplate() {
      this.uploadLabelDialog.loading = true
      this.readLabelTemplate(this.uploadLabelDialog.file, this.uploadLabelDialog.labels).then(data => {
        if (data.length === 0) throw new Error('模板中未填写有效的自定义标签数据')
        this.chooseData.dataPlus.selectArea = [...this.chooseData.dataPlus.selectArea, ...data]
        this.$message.success('添加成功');
      }).then(() => {
        this.uploadLabelDialog.visible = false
        this.uploadLabelDialog.file = null
      }).catch(error => {
        this.$notify.error({
          title: '错误',
          message: error.message || '自定义标签上传失败',
          position: 'bottom-right'
        })
      }).finally(() => this.uploadLabelDialog.loading = false)
    },
    openSaleUpload() {
      this.uploadSaleDialog = {
        visible: true,
        loading: false,
        file: null
      }
    },
    downloadSaleTemplate() {
      // 定义表头
      const headers = ['导购id或手机号']
      // 格式化数据
      const formattedData = []
      // 导出Excel
      export_json_to_excel({
        header: headers,
        data: formattedData,
        filename: '提成规则导购应用范围上传模板',
        autoWidth: true,
        bookType: 'xlsx'
      })
    },
    uploadSaleTemplate() {
      const supplierId = this.dialogData.dialogSupplierId
      this.uploadSaleDialog.loading = true
      let formData = new FormData()
      formData.append("file", this.uploadSaleDialog.file)
      formData.append("supplierId", supplierId)
      uploadSaleTemplate(this.token,formData).then(res => {
        if (res.data.code === 1) {
          this.$notify.error({
            title: '失败',
            message: res.data.msg,
            position: 'bottom-right'
          })
        } else {
          this.chooseData.dataPlus.selectArea = [...this.chooseData.dataPlus.selectArea, ...res.data.date];
          this.$notify.success({
            title: '成功',
            message: '提成规则导购应用范围上传成功，共添加' + res.data.date.length + "位导购",
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.uploadSaleDialog = {
          visible: false,
          loading: false,
          file: null
        }
      })
    },
    tableRowClassName({row, rowIndex}) {
      const {packageId} = row
      if (this.packageIds.length > 0 && this.packageIds.includes(packageId)) {
        return 'success-row'
      }
      return ''
    }
  },
  mounted() {
    let date = new Date();
    date.setDate(1);
    let Y1 = date.getFullYear();
    let M1 = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let firstDayOfMonth = Y1 + '-' + M1 + '-01';
    date.setMonth(date.getMonth() + 3);
    let Y2 = date.getFullYear();
    let M2 = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let threeMonthsLater = Y2 + '-' + M2 + '-01';
    this.queryParams.range = [firstDayOfMonth, threeMonthsLater];
    this.token = localStorage.getItem('token')
    packageInit(this.token).then(({data}) => {
      let {date} = data
      this.suppliers = date
      let queryParams = localStorage.getItem('queryParams')
      if (queryParams) {
        this.queryParams = JSON.parse(queryParams)
        localStorage.removeItem('queryParams')
      }
      if (this.suppliers.length == 1) {
        this.$set(this.form, "supplierId", [this.suppliers[0].id])
        this.supplierChange(this.suppliers[0])
        this.handleQuery();
      } else {
        let supplierId = this.$route.query.supplierId
        if (supplierId) {
          this.queryParams.supplierId = supplierId
          this.handleQuery()
        }
      }
    }).catch(error => {
      let status = error.response.status;
      if (status == 500) {
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  filters: {
    cycleDayFilter: function (value) {
      switch (value) {
        case 1:
          return '每天'
        case 7:
          return '自然周'
        case 30:
          return '自然月'
      }
    },
    rewardBenchmarkFilter: function (value) {
      switch (value) {
        case 'tc_1':
          return '销售数'
        case 'tc_2':
          return '金额比例'
        case 'tc_3':
          return '单笔固定金额'
      }
    },
    combinationModeFilter: function (value) {
      switch (value) {
        case 'zh_dp':
          return '单品'
        case 'zh_ry':
          return '任意组合'
      }
    },
    gradientRuleFilter: function (value) {
      switch (value) {
        case 'js_period':
          return '周期内加总'
        case 'js_ticket':
          return '单张小票结算'
      }
    },
    gradientBenchmarkFilter: function (value) {
      switch (value) {
        case 'mk_1':
          return '销售数'
        case 'mk_2':
          return '销售金额'
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  padding-top: 30px;
}

.activityForm /deep/ .el-form-item {
  margin-bottom: 0px;
}

>>> .el-dialog .el-form-item__content .el-select {
  display: inline-block;
  position: relative;
  width: 100% !important;
  margin-left: 0 !important;
  margin-bottom: 10px;
}

.title {
  font-weight: 600;
  font-size: 15px;
  color: #979797;
  line-height: 40px;
  display: inline-block;
}

>>> .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #ED7043;
  font-weight: 600;
}

>>> .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 0 25px 30px;
}

.tags {
  margin: 3px;
  color: #979797;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}

>>> .selectBorderRadius .el-input__inner {
  border-radius: 5px 0 0 5px;
  padding: 0 0 0 13px;
}

>>> .downLoadManager .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}


>>> .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 10px;
  font-weight: 800;
  font-size: 17px;
  color: black;
}

.tag {
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 5px;
}

.uploadDialog .dialog-title {
    margin-top: 10px;
    color: black;
    font-size: 24px;
    font-weight: 600;
}
.uploadDialog .description {
    color: #979797;
    background-color: #F3F3F3;
    padding: 10px;
    border-radius: 10px;
    text-align: left;
    line-height: 23px;
}
.tags-cover >>> .el-icon-close {
  color: #ffffff;
}
.el-checkbox >>> .el-checkbox__label {
  display: none;
  font-size: 0;
}
</style>

<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
